import { render } from "./BalanceView.vue?vue&type=template&id=1a95a0b2"
import script from "./BalanceView.vue?vue&type=script&lang=js"
export * from "./BalanceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/BalanceView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a95a0b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a95a0b2', __exports__)) {
    api.reload('1a95a0b2', __exports__)
  }
  
  module.hot.accept("./BalanceView.vue?vue&type=template&id=1a95a0b2", () => {
    api.rerender('1a95a0b2', render)
  })

}


export default __exports__